import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {useEffect} from 'react';

import {RootState} from '../../../index';
import {getMyOverallHighlightsState} from '../../../selectors/fortnite-game/myOverallHighlightsSelector';
import {MyOverallHighlightsState} from '../../../reducers/fortnite-game/myOverallHighlights.reducer';
import actionsHighlights from '../../../actions/fortnite-game/myOverallHighlights.actions';

const useMyOverallHighlightsData = (): MyOverallHighlightsState => {
    const dispatch = useDispatch();

    const {totals, monthly, weekly} = useSelector<RootState, MyOverallHighlightsState>(
        getMyOverallHighlightsState,
        shallowEqual
    );

    useEffect(() => {
        const requests = [{value: 'totals'}, {value: 'monthly'}, {value: 'weekly'}];

        requests.forEach(params => {
            dispatch(
                actionsHighlights.getHighlights({
                    ...params
                })
            );
        });
    }, []);

    return {
        totals,
        monthly,
        weekly
    };
};

export default useMyOverallHighlightsData;
